









































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CartItem } from '@/store/models';
import cart from '@/store/modules/cart';
import user from '@/store/modules/user';
import ui from '@/store/modules/ui';
import Modal from '@/components/UI/Modal.vue';
import gtmhelpers from '@/commons/gtmhelpers';
import handleMessage from '@/commons/messageManager';
import OmnibusPrice from './OmnibusPrice.vue';

@Component({
    components: {
        Modal,
        OmnibusPrice,
    },
})
export default class CartItemComp extends Vue {
    public isRemoving: boolean = false;
    private isDisabled: boolean = false;

    @Prop() private item!: CartItem;

    get qtyIncs(): number[] {
        let length = 100;
        const extensionAttributes = this.item.extension_attributes;

        // PU FPAS check (PassioneUnghie\Catalog\README.md for more info)
        if (extensionAttributes.extpu_max_sale_qty && !extensionAttributes.extcustom_price) {
            length = extensionAttributes.extpu_max_sale_qty;
        }

        return Array.from({ length }, (_element, index) => 1 + index).filter(
            (element) => element % extensionAttributes.extqty_increments === 0,
        );
    }

    get isLogged(): boolean {
        return user.isLoggedin;
    }

    get qty(): number {
        return this.item.qty;
    }

    set qty(value: number) {
        this.incrementQty(this.item, value);
    }

    get isSalable(): boolean {
        return this.item.extension_attributes.extis_salable && this.item.extension_attributes.extitem_error === '';
    }

    get isGift(): boolean {
        return false;
    }

    get isVipQuote(): boolean {
        return cart.cart.extension_attributes && cart.cart.extension_attributes.is_vip_cart;
    }

    get items(): CartItem[] {
        return cart.cart.items;
    }

    get isDisabledBtn(): boolean {
        return this.isDisabled;
    }

    set isDisabledBtn(bool: boolean) {
        this.isDisabled = bool;
    }

    get customerId(): any {
        return user.customer.id;
    }

    get textBtnDelete(): string {
        if (this.isLogged) {
            return `${this.$t('Do you want to add the product to your wish list before removing it?').toString()}`;
        }
        return `${this.$t('Are you sure you want to delete this item from cart?').toString()}`;
    }

    public getFinalPrice(item: CartItem) {
        return item.extension_attributes.extcustom_price || item.extension_attributes.extfinal_price;
    }

    public showOldPrice(item: CartItem) {
        return item.extension_attributes.extoriginal_price > this.getFinalPrice(item);
    }

    public showOmnibusPrice(item: CartItem) {
        return item.extension_attributes.extomnibus_price > 0;
    }

    public getDiscountPercentage(regularPrice: number, finalPrice: number) {
        return `${Math.round(((regularPrice - finalPrice) / regularPrice) * 100)}%`;
    }

    private openModal(item: CartItem) {
        ui.openModal(`deleteItem${item.item_id}`);
    }

    private closeModal(item: CartItem) {
        ui.closeModal(`deleteItem${item.item_id}`);
    }

    private async incrementQty(item: CartItem, qty: number) {
        if (qty < 1) {
            return;
        }

        const oldQty = item.qty;

        cart.setQty({ itemId: item.item_id, qty });
        await cart.updateQty({ item, oldQty });

        if (qty > oldQty) {
            item.qty = qty - oldQty;
            gtmhelpers.trackAdd(gtmhelpers.convertProductsData([item]));
        } else {
            item.qty = oldQty - qty;
            gtmhelpers.trackRemove(gtmhelpers.convertProductsData([item]));
        }

        item.qty = qty;
    }

    private async deleteItem(item: CartItem) {
        this.isRemoving = true;
        await cart.deleteCartItem(item.item_id);
        this.isRemoving = false;

        gtmhelpers.trackRemove(gtmhelpers.convertProductsData([item]));
    }

    private async addToWishlist(item: CartItem) {
        this.isDisabledBtn = true;
        const itemConverted = gtmhelpers.convertProductsData([item]);
        const isAdded = await cart.addToWishlist(itemConverted[0].id);

        if (isAdded) {
            handleMessage('success', this.$t('Added to wishlist').toString());
            gtmhelpers.addToWishlist(itemConverted);
        }

        this.deleteItem(item);
        this.isDisabledBtn = false;
    }

    private isItemFree(item: CartItem) {
        return item.extension_attributes.extfree_gift_message !== '';
    }

    private getPrice(item: CartItem) {
        let val = 0;

        // If custom price is set, return that regardless
        if ((item.extension_attributes.extcustom_price || 0) > 0) {
            return item.extension_attributes.extcustom_price;
        }

        // If giftcard take the standard price (can't have tier prices)
        if (item.product_type === 'giftcard') {
            return item.price;
        }

        item.extension_attributes.exttier_prices.some((price) => {
            if (!val && item.qty >= price.qty) {
                val = price.value;
                return true;
            }

            return false;
        });

        return item.extension_attributes.extcustom_price || val || item.extension_attributes.extfinal_price;
    }
}
